import { useSnapshot } from 'valtio';
import Input from '~/components2/forms/Input';
import rootStore from '~/store';

export default function OrgId() {
  const { currentOrganizationDetail } = useSnapshot(rootStore) as typeof rootStore;

  if (currentOrganizationDetail.isLoading) {
    return null;
  }

  return (
    <div className="flex w-2/3 flex-col">
      <div className="text-sm font-bold">Organization ID</div>
      <div className="w-2/3 pb-2 text-sm">
        Support may ask for this ID when you report a problem with your organization.
      </div>

      <span className="w-[300px]">
        <Input label="" value={currentOrganizationDetail.id} readOnly canCopy data-testid="org-id-input" />
      </span>
    </div>
  );
}
